<template>
  <div class="resetPassword container h-100">
    <div class="content">
      <h2 style="color:red;text-align:left;">修改资料</h2>
      <el-form :model="userForm" class="userForm" ref="refUserForm" :rules="rules" label-width="100px"
               style="text-align:left;padding:0 120px;">
        <el-row>
          <el-col :span="11">
            <el-row>
              <el-form-item label="昵称" prop="name">
                <el-input v-model="userForm.name" placeholder="请输入昵称"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="账号" prop="username">
                <el-input v-model="userForm.username" placeholder="请输入账号"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="性别">
                <el-radio-group v-model="userForm.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="头像" prop="avatar" class="logo">
                <el-upload
                    class="upload-demo"
                    action="/api/upload/import"
                    :headers="header"
                    name="file"
                    :file-list="fileList"
                    :on-change="handleChange"
                    :on-success="handleSuccess"
                    list-type="picture">
                  <el-button size="small" type="primary">上传图片</el-button>
                  <div style="margin-top:20px;">
                    <el-avatar shape="square" size="large" :src="userForm.avatar"
                               style="width:80px;height:80px;" @error="()=>{return true}">
                      <img :src="userForm.avatar"/>
                    </el-avatar>
                  </div>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:40px;">
              <el-col :span="8" style="text-align:center;">
                <el-button type="primary" @click="onSubmit">立即提交</el-button>
                <!--                <el-button type="primary" @click="onSubmit">同步钉钉信息</el-button>-->
              </el-col>
            </el-row>
          </el-col>
          <el-col :offset="1" :span="11">
            <h4 v-if="dingBound">已绑定钉钉：{{dingNick}}</h4>
            <h4 v-else>钉钉绑定</h4>
            <div v-if="dingBound" style="text-align:left;">
              <el-button type="primary" plain @click="unbind">与钉钉解绑</el-button>
              <p style="margin-top:10px;font-size:12px;color:#909399;">解绑后可在本页重新主动扫码绑定钉钉</p>
            </div>
            <div v-else style="text-align:left;">
              <el-button type="primary" @click="openBindDd">去绑定钉钉</el-button>
              <p style="margin-top:10px;font-size:12px;color:#909399;">绑定后可使用钉钉免登等服务</p>
            </div>

            <div style="margin-top:30px;border-top:1px solid #ebeef5;padding-top:24px;"></div>
            <h4 v-if="fsBound">已绑定飞书</h4>
            <h4 v-else>飞书绑定</h4>
            <div v-if="fsBound" style="text-align:left;">
              <el-button type="danger" plain @click="unbindFs">与飞书解绑</el-button>
              <p style="margin-top:10px;font-size:12px;color:#909399;">解绑后将无法使用飞书免登、飞书消息通知等服务</p>
            </div>
            <div v-else style="text-align:left;">
              <el-button type="primary" plain @click="openBindFs">去绑定飞书</el-button>
              <p style="margin-top:10px;font-size:12px;color:#909399;">绑定后可使用飞书免登、飞书消息通知等服务</p>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 钉钉扫码绑定弹窗（复用封装组件 BindDingDing/index.vue） -->
      <bind-ding-ding :key="bindKey" @success="bindDdSuccess" ref="bindDingTalk"/>
    </div>
  </div>
</template>

<script>
import {updateInfo} from '@/api/user'
import {unbindDingDing, unbindFeishu} from '@/api/login'
import {myBaseInfo, myThirdPartyBindings} from "@/api/user";
import {logout} from "@/api/login";
import {getAuthUser, setAuthUser} from "@/utils/auth";
import {getFeishuApp} from "@/api/common";
import {buildFeishuAuthorizeUrl, getFeishuRedirectUri} from "@/utils/feishu";
import BindDingDing from "@/components/BindDingDing/index.vue";

export default {
  name: 'updateInfo',
  components: {BindDingDing},
  data() {
    return {
      userForm: {
        username: '',//账号
        name: '',//name
        email: '',
        sex: 1,
        avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
        id: '',
        type: 'update',
        is_bind_dd: false,
        dingding: false,
      },
      showBindBtn: false,
      showBindView: false,
      is_bind_dd: true,
      // 我的第三方（钉钉/飞书）绑定检测结果
      thirdPartyBindings: null,
      // 钉钉主动扫码绑定弹窗重挂 key
      bindKey: new Date().getTime(),
      bindForm: {
        is_bind: true,
        nick: '',
        account: '',
        unionid: '',
        openid: '',
      },
      avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      rules: {
        email: [
          {required: true, message: '邮箱不能为空', trigger: 'blur'},
          {type: 'email', message: '请输入正确邮箱格式', trigger: 'blur'}
        ],
        avatar: [
          {required: false, message: '头像不能为空', trigger: 'blur,change'}
        ],
        username: [
          {required: true, message: '账号不能为空', trigger: 'blur,change'}
        ],
        name: [
          {required: true, message: '昵称不能为空', trigger: 'blur,change'}
        ]
      },
      fileList: [],
      header: {},
    }
  },

  computed: {
    // 是否已绑定飞书（fs_union_id/fs_open_id/fs_user_id 任一非空）
    // 钉钉是否已绑定：优先取第三方绑定检测，回退 myBaseInfo 字段
    dingBound() {
      if (this.thirdPartyBindings) {
        return !!this.thirdPartyBindings.dingding.bound
      }
      const d = this.userForm || {}
      return !!(d.is_bind_dd || d.dingding)
    },
    // 钉钉绑定昵称
    dingNick() {
      if (this.thirdPartyBindings && this.thirdPartyBindings.dingding.nick) {
        return this.thirdPartyBindings.dingding.nick
      }
      const d = this.userForm || {}
      return (d.dingding && d.dingding.nick) ? d.dingding.nick : ''
    },
    // 飞书是否已绑定：优先取第三方绑定检测，回退原 fs 字段判断
    fsBound() {
      if (this.thirdPartyBindings) {
        return !!this.thirdPartyBindings.feishu.bound
      }
      const d = this.userForm || {}
      return !!(d.fs_union_id || d.fs_open_id || d.fs_user_id)
    }
  },

  async created() {
    //加载用户个人信息
    await this.getUserDetail()
    this.loadBindings()
    if (this.getToken()) {
      this.header = {
        'Authorization': 'Bearer ' + this.getToken()
      }
    }
  },
  methods: {
    // eslint-disable-next-line
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.userForm.avatar = response.model.url
      }
    },
    async getUserDetail() {
      await myBaseInfo().then(res => {
        this.userForm = res.model
      })
    },
    // 第三方绑定检测（钉钉/飞书）
    async loadBindings() {
      try {
        const res = await myThirdPartyBindings()
        this.thirdPartyBindings = res.model
      } catch (e) {
        this.thirdPartyBindings = null
      }
    },
    // eslint-disable-next-line
    handleChange(file, fileList) {
      this.fileList = [file]
    },
    onSubmit() {
      this.$refs['refUserForm'].validate((valide) => {
        if (valide) {
          updateInfo(this.userForm).then((res) => {
            if (res.success) {
              this.showToast({h: this, text: '修改成功'});
              this.showModal({
                h: this,
                text: "用户信息已修改，是否重新登录？",
                confirmText: "",
                cancelText: "",
                confirm: () => {
                  logout().then(() => {
                    this.$router.push({name: 'login'});
                    this.$ls.clear()
                  })
                },
                cancel: () => {
                  this.getUserDetail()
                  // console.log("cancel");
                }
              });
            }
          })
        } else {
          this.showToast({h: this, text: '有必填项未填或校验不通过', icon: 'el-icon-warning'})
        }
      })
    },
    // 解绑
    unbind() {
      const that = this
      this.showModal({
        h: this,
        text: "是否确定要与您的钉钉账号解绑",
        confirmText: "确定",
        cancelText: "取消",
        confirm: function () {
          unbindDingDing({}).then(() => {
            that.$message.success('解绑成功')
            that.getUserDetail()
            that.loadBindings()
            // 更新本地绑定状态，页面右侧切换为「去绑定钉钉」
            const user = getAuthUser()
            user.is_bind_dd = 0
            setAuthUser(user)
          });
        },
        cancel: function () {
          that.$message({
            type: 'info',
            message: '已取消解绑'
          });
        }
      });
    },
    // 主动调出钉钉扫码绑定
    openBindDd() {
      // 清除「已弹窗」记忆，重挂组件后 init() 会立即弹出
      localStorage.removeItem('showBindDD')
      this.bindKey = new Date().getTime()
    },
    //扫码绑定成功
    bindDdSuccess() {
      this.getUserDetail()
      this.loadBindings()
    },
    // 主动调出飞书授权绑定（跳转飞书授权页，授权完成后回调 /home 由全局 bind-feishu 绑定到当前账号）
    async openBindFs() {
      try {
        const {model} = await getFeishuApp()
        if (!model || !model.app_id) {
          this.$message.error('飞书应用未配置，请联系管理员')
          return
        }
        window.location.href = buildFeishuAuthorizeUrl(model, getFeishuRedirectUri('/home'), 'feishu')
      } catch (e) {
        this.$message.error('获取飞书配置失败，请重试')
      }
    },
    // 飞书解绑
    unbindFs() {
      const that = this
      this.showModal({
        h: this,
        text: "是否确定要与您的飞书账号解绑",
        confirmText: "确定",
        cancelText: "取消",
        confirm: function () {
          unbindFeishu({}).then(() => {
            that.$message.success('解绑成功')
            that.getUserDetail()
            that.loadBindings()
            // 更新本地绑定状态，页面右侧切换为「未绑定飞书」
            const user = getAuthUser()
            user.fs_union_id = ''
            user.fs_open_id = ''
            user.fs_user_id = ''
            setAuthUser(user)
          });
        },
        cancel: function () {
          that.$message({
            type: 'info',
            message: '已取消解绑'
          });
        }
      });
    }
  },
  mounted() {
    // 默认不打开钉钉绑定窗口
    this.$refs['bindDingTalk'].handleClose()
  }
}
</script>

<style scoped>
.resetPassword {
  /*margin-top: 70px;*/
}

.content {
  background: #fff;
  padding: 24px 30px 0 30px;
}
</style>
<style>
.el-avatar.el-avatar--large.el-avatar--square img {
  width: 100%
}

.logo .el-upload-list.el-upload-list--picture {
  display: none;
}
</style>
